export default __webpack_public_path__ + "static/media/info.f4b624f7.png";